import React from "react";

function About() {
    return ( <div className="AppHome">
        About
    </div>
    );
}

export default About;